'use strict';

var _ = require('lodash');
var angular = require('angular');
var LastYearValueTooltipFactory = function LastYearValueTooltipFactory() {
  var HIDE_DELAY = 50;
  var DISPLAY_CONFIG = {
    currentLoadFactor: {
      lastYearValue: 'lastYearCurrentLoadFactor'
    },
    currentRASd: {
      lastYearValue: 'lastYearCurrentRASd'
    },
    expectedLoadFactor: {
      lastYearValue: 'lastYearFinalLoadFactor'
    },
    expectedRASd: {
      lastYearValue: 'lastYearFinalRASd'
    },
    expectedRevenue: {
      lastYearValue: 'lastYearFinalRevenue'
    },
    expectedBookings: {
      lastYearValue: 'lastYearFinalBookings'
    },
    avgFare: {
      lastYearValue: 'lastYearAvgFare'
    },
    segClassCurrentBookings: {
      lastYearValue: 'segClassLastYearCurrentBookings'
    },
    segClassCurrentRevenue: {
      lastYearValue: 'segClassLastYearCurrentRevenue'
    },
    segClassExpectedBookings: {
      lastYearValue: 'segClassLastYearFinalBookings'
    },
    segClassExpectedRevenue: {
      lastYearValue: 'segClassLastYearFinalRevenue'
    },
    resHoldTotal: {
      lastYearValue: 'lastYearCurrentBookings'
    },
    bookings: {
      lastYearValue: 'lastYearBookings'
    },
    bookingsExpected: {
      lastYearValue: 'lastYearFinalBookings'
    },
    currentRevenue: {
      lastYearValue: 'lastYearCurrentRevenue'
    },
    mappedBookings: {
      lastYearValue: 'lastYearMappedBookings'
    },
    mappedCurrentRevenue: {
      lastYearValue: 'lastYearMappedCurrentRevenue'
    },
    mappedExpectedRevenue: {
      lastYearValue: 'lastYearMappedFinalRevenue'
    },
    mappedExpectedBookings: {
      lastYearValue: 'lastYearMappedFinalBookings'
    },
    compFareDiff: {
      currentValue: 'hostFare',
      currentLabel: 'Host Fare:',
      lastYearValue: 'lowestCompFare',
      lastYearLabel: 'Lowest Comp Fare:'
    }
  };
  var DYNAMIC_COLUMN_GROUP = ['loadFactorField'];
  var BOOKING_INTAKE_PERFORMANCE_TOTAL = 'bookingIntakePerformanceTotal';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS = 'bookingIntakePerformanceGroupBookings';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR = 'bookingIntakePerformanceLoadFactor';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN = 'bookingIntakePerformanceLowestClassOpen';
  var BOOKING_INTAKE_PERFORMANCE_TOTAL_LY = 'bookingIntakePerfTotalBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY = 'bookingIntakePerfGroupBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY = 'bookingIntakePerfLoadFactorLY';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY = 'bookingIntakePerfLowestClassOpenLY';
  var BOOKING_INTAKE_PERFORMANCE_MAP = {};
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_TOTAL] = BOOKING_INTAKE_PERFORMANCE_TOTAL_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS] = BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR] = BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN] = BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY;
  var BOOKING_INTAKE_FIELDS = [BOOKING_INTAKE_PERFORMANCE_TOTAL, BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS, BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR, BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN];
  function LastYearValueTooltip() {}
  LastYearValueTooltip.constructor = LastYearValueTooltip;
  function renderValue(rendererName, value) {
    if (rendererName === 'percentageRender' && value !== '') {
      return Math.round(value * 10000) / 100;
    }
    return value;
  }
  function findDynamicDisplayConfig(columnName) {
    var found = _.find(DYNAMIC_COLUMN_GROUP, function (config) {
      return columnName.indexOf(config) === 0;
    });
    return found ? {
      lastYearValue: 'lastYear' + columnName
    } : undefined;
  }
  function findBookingIntakeConfig(columnName) {
    var fieldName = _.find(BOOKING_INTAKE_FIELDS, function (fieldname) {
      return _.includes(columnName, fieldname);
    });
    var offset = _.chain(columnName).clone().thru(function (datafield) {
      return _.replace(datafield, fieldName, '');
    }).value();
    return fieldName ? {
      currentValue: columnName,
      lastYearValue: BOOKING_INTAKE_PERFORMANCE_MAP[fieldName] + offset
    } : undefined;
  }
  function getHtmlContent(cellData, wholeGridData, displayConfig, currentValue, lastYearValue) {
    var valueChange = currentValue - lastYearValue;
    var tooltipData = {
      currentValue: currentValue,
      currentLabel: displayConfig.currentLabel ? displayConfig.currentLabel : 'Current Value:',
      lastYearValue: lastYearValue,
      lastYearLabel: displayConfig.lastYearLabel ? displayConfig.lastYearLabel : 'Last Year:',
      change: valueChange
    };
    for (var prop in tooltipData) {
      if (!_.includes(['currentValue', 'lastYearValue', 'change'], prop)) {
        continue;
      }
      if (!_.isEmpty(cellData.valueformat)) {
        tooltipData[prop] = angular.element.jqx.dataFormat.formatnumber(tooltipData[prop], cellData.valueformat);
      } else if (!_.isEmpty(cellData.rendererName)) {
        tooltipData[prop] = renderValue(cellData.rendererName, tooltipData[prop]);
      }
    }
    tooltipData.change = valueChange > 0 ? '+' + tooltipData.change : tooltipData.change;
    tooltipData.increased = valueChange > 0;
    var tooltipContent = _.template(require('../templates/last-year-value-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  LastYearValueTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      var displayConfig = DISPLAY_CONFIG[cellData.column] || findDynamicDisplayConfig(cellData.column) || findBookingIntakeConfig(cellData.column);
      var currentValue = wholeGridData[cellData.row][displayConfig.currentValue ? displayConfig.currentValue : cellData.column];
      var lastYearValue = wholeGridData[cellData.row][displayConfig.lastYearValue];
      if ((cellData.value || cellData.value === 0) && !_.isNil(currentValue) && !_.isNil(lastYearValue)) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData, displayConfig, currentValue, lastYearValue),
          hideDelay: HIDE_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return LastYearValueTooltip;
};
module.exports = LastYearValueTooltipFactory;